import { useRouter } from "next/router"
import { useEffect } from "react"

export default function ContactForm() {
  const router = useRouter()

  useEffect(() => {
    const { name, email } = router.query
    ;(window as any).FreshworksWidget("open", "ticketForm")
    ;(window as any).FreshworksWidget("identify", "ticketForm", {
      name,
      email
    })
  })
  return <></>
}
